import { Genki, GenkiModule } from '@gig/genki';
import { __ENV__, MOCK_ID, BASE_URL, MERCHANT_API } from './constant.js';

Genki.Env = __ENV__;

Genki.mockId = MOCK_ID;

const apiConfig: GenkiModule = {
  getPayResult: {
    api: `${BASE_URL}/v4/checkout/queryPaymentResult`,
    params: {
      token: {
        type: String,
        required: true,
      },
      payRequestId: {
        type: String,
        required: false,
      },
    },
  },

  addFeedback: {
    api: `${MERCHANT_API}/merchant/customerFeedback/addFeedback`,
    method: 'POST',
    params: {
      orderId: {
        type: String,
        required: true,
      },
      feedbackInfoList: {
        type: Array,
        required: true,
      },
    },
  },
};

export const genki = new Genki(apiConfig);